import React, { useState, useEffect, useRef } from "react";
import "./TontonNavbar.css";
import { trackNaviClick } from '../lib/gtm';
import { Navbar, Nav, Container } from "react-bootstrap";


const TontonNavbar = ({ toggleVideoPlayer }) => {
    const [activeFilter, setActiveFilter] = useState('ALL');
    const [isMobile, setIsMobile] = useState(false);
    const [hamburger, setHamburger] = useState('');
    const [standard, setStandard] = useState('');
    const [sideMenu, setSideMenu] = useState('close');
    const [isOpen, setIsOpen] = useState('close');
    const [searchInput,setSearchInput] = useState('');
    let inputRef = useRef(null);
    let mobileInputRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const filters = ["All", "BHTV", "NSTTV", "HMTV", "BUTV3", "8TV", "OHBULAN!", "SAYS"];

    const handleSearch = () => {
        if(!searchTerm.trim()) return;
        const encodedQuery = encodeURIComponent(searchTerm);
        window.location.href = `https://watch.tonton.com.my/#/search/${encodedQuery}`;
        
    }



    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    }

    const handleClick = (event) => {
        if (inputRef.current && inputRef.current.contains(event.target)) {
            setIsOpen('open'); // Close menu if clicked outside
        } else {
            setIsOpen('close');
        }

    };

    

    const mobileHandleClick = (event) => {
        if (mobileInputRef.current && mobileInputRef.current.contains(event.target)) {
            setSearchInput('open')
        }

    };

    

    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
            if (isMobile) {
                setHamburger('open');
            } else {
                setStandard('standard');
            }
        }

        checkScreenSize();

        window.addEventListener('resize', checkScreenSize);
        window.removeEventListener('resize', checkScreenSize);

        document.addEventListener("mousedown", handleClick); // Add global event listener
        return () => {
            document.removeEventListener("mousedown", handleClick); // Cleanup
        };

    }, [])

    const toggleHamburger = () => {
        setSideMenu((prevState) => (prevState === "close" ? "open" : "close"));
        setHamburger((prevState) => (prevState === "open" ? "" : "open"));
    }



    return (
        <div>
            {/* 
            <Navbar expand="lg" variant="dark" className={`container-fluid ${styles.navbarBg}`}>
                <Container>
                    <Navbar.Brand href="/"><img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:SERVICE_LOGO_default:png&h=60&appID=TONTON" alt="Tonton logo" className={styles.logo} /></Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" >
                        <Nav className={styles.customNavbarNav}>
                            <Nav.Link href="https://watch.tonton.com.my/#/">Home</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/live">Live TV</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/Dramas">Dramas</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/series">TV Shows</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/Cinema">Cinema</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/Chinese">Chinese</Nav.Link>
                            <Nav.Link href="https://watch.tonton.com.my/#/Events">Events</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar> */}
            {isMobile ?
                <div className="menu-bar-container">
                    <div>
                        <div className="menu-bar hamburger show">
                            <div className="left-section">
                                <div className="hamburger-icon-holder">
                                    <div className={`hamburger-icon ${hamburger}`} tabindex="0" aria-label="Main Menu" aria-expanded="false" onClick={toggleHamburger}>
                                        <span className="hamburger-line"></span>
                                        <span className="hamburger-line"></span>
                                        <span className="hamburger-line"></span>
                                        <span className="hamburger-line"></span>
                                    </div>
                                </div>
                                <div className={`side-menu ${sideMenu}`}>
                                    <div className="menu-item active HOMEmobile"><a href="https://watch.tonton.com.my/">Home</a>
                                        <div className="light-bar"></div>
                                    </div>
                                    <div className="menu-item LIVEmobile"><a href="https://watch.tonton.com.my/#/live/tv3">Live TV</a></div>
                                    <div className="menu-item DRAMASmobile"><a href="https://watch.tonton.com.my/#/Dramas">Dramas</a></div>
                                    <div className="menu-item SERIESmobile"><a href="https://watch.tonton.com.my/#/series">TV Shows</a></div>
                                    <div className="menu-item MOVIESmobile"><a href="https://watch.tonton.com.my/#/Cinema">Cinema</a></div>
                                    <div className="menu-item /Chinesemobile"><a href="https://watch.tonton.com.my/#/Chinese">Chinese</a></div>
                                    <div className="menu-item EVENTSmobile"><a href="https://watch.tonton.com.my/#/Events">Events</a></div>
                                </div>
                                <div className="logo" tabindex="0">
                                    <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:SERVICE_LOGO_default:png&amp;h=60&amp;appID=TONTON" />
                                </div>
                            </div>
                            <div className="right-section">
                                {/* <div className={`search-menu-item toolbar-item ${searchInput}`} ref={mobileInputRef} onClick={mobileHandleClick}>
                                    <div className="search-inner">
                                    <input
                                            placeholder="Search"  onKeyDown={handleKeyPress} id="input-search" onChange={(e)=>setSearchTerm(e.target.value)}/>
                                        <div className="search-icon" tabindex="0">
                                            <span className="toggleable-image">
                                                <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SEARCH:png&amp;&amp;appID=TONTON" className="default-image" onClick={handleSearch}/>
                                                <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SEARCH_SELECTED:png&amp;&amp;appID=TONTON" className="selected-image" /></span></div>
                                        
                                    </div>
                                </div>
                                <div className="settings toolbar-item">
                                    <div className="icon settings-icon" tabindex="0" aria-expanded="false" aria-label="Settings">
                                        <span className="toggleable-image">
                                            <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SETTINGS:png&amp;&amp;appID=TONTON" className="default-image" />
                                            <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SETTINGS_SELECTED:png&amp;&amp;appID=TONTON" className="selected-image" />
                                        </span></div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div> : <div className="menu-bar-container sideMenuOpen">
                    <div>
                        <div className={`menu-bar ${hamburger} ${standard} show`}>
                            <div className="left-section">
                                <div className="logo" tabindex="0">
                                    <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:SERVICE_LOGO_default:png&amp;h=60&amp;appID=TONTON" />
                                </div>
                                <div tabindex="0" className="menu-item HOME"><a href="https://watch.tonton.com.my/">Home</a></div>
                                <div tabindex="0" className="menu-item LIVE"><a href="https://watch.tonton.com.my/#/live/tv3">Live TV</a></div>
                                <div tabindex="0" className="menu-item DRAMAS"><a href="https://watch.tonton.com.my/#/Dramas">Dramas</a></div>
                                <div tabindex="0" className="menu-item SERIES"><a href="https://watch.tonton.com.my/#/series">TV Shows</a></div>
                                <div tabindex="0" className="menu-item MOVIES"><a href="https://watch.tonton.com.my/#/Cinema">Cinema</a></div>
                                <div tabindex="0" className="menu-item active /Chinese"><a href="https://watch.tonton.com.my/#/Chinese">Chinese</a>
                                    <div className="light-bar"></div>
                                </div>
                                <div tabindex="0" className="menu-item EVENTS"><a href="https://watch.tonton.com.my/#/Events">Events</a></div>
                            </div>
                            <div className="right-section">
                                {/* <div className={`search-menu-item toolbar-item ${isOpen}`} ref={inputRef} onClick={handleClick}>
                                    <div className="search-inner">

                                        <input
                                            placeholder="Search" spellcheck="false" tabindex="-1" type="text" onKeyDown={handleKeyPress} id="input-search" onChange={(e)=>setSearchTerm(e.target.value)} />
                                        <div className="search-icon" tabindex="0">
                                            <span className="toggleable-image">
                                                <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SEARCH:png&amp;&amp;appID=TONTON" className="default-image" onClick={handleSearch} />
                                                <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SEARCH_SELECTED:png&amp;&amp;appID=TONTON" className="selected-image" />
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className="settings toolbar-item">
                                    <div className="icon settings-icon" tabindex="0" aria-expanded="false" aria-label="Settings">
                                        <span className="toggleable-image">
                                            <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SETTINGS:png&amp;&amp;appID=TONTON" className="default-image" />
                                            <img src="https://headend-api.tonton.com.my/v210/imageHelper.php?id=0:377:STATIC:MENU_ICON_SETTINGS_SELECTED:png&amp;&amp;appID=TONTON" className="selected-image" />
                                        </span>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>}


            {/* Filter Section   */}
            <div className="filterSection">
                {filters.map((filter, index) => (
                    <button key={index} className={`filter ${activeFilter === filter ? 'activeFilter' : ""}`}
                        onClick={() => {
                            setActiveFilter(filter);
                            toggleVideoPlayer(filter);
                            trackNaviClick(filter);
                        }}>{filter}</button>
                ))}
            </div>
        </div>
    )
}
export default TontonNavbar;